export default {
      id: "plus-usage",
      viewBox: "0 0 20 20",
      url: "../../assets/" + "sprite.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }